import { IIssueMachineHealthResponse } from '@kcftech/prometheus-client';
import { IssueDisabledPopup } from 'pages/Desk/issues/issue_card/IssueDisabledPopup';
import { issueGroupUnboundMessage } from 'pages/Desk/issues/shared';
import { useMemo } from 'react';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';
import { buildHierarchy } from 'utils/group_hierarchy';

const Container = styled.div`
    color: ${tokens.error.default};
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
`;

type IssueHierarchyProps = {
    id?: string;
    issue: IIssueMachineHealthResponse;
};

export function IssueHierarchy({ id, issue }: IssueHierarchyProps) {
    const hierarchyString = useMemo(
        () => buildHierarchy(issue.Hierarchy, true, true),
        [issue.Hierarchy],
    );

    if (issue.Group === undefined) {
        return <IssueGroupUnboundMessage id={id} />;
    }

    return <span id={id}>{hierarchyString}</span>;
}

export function IssueGroupUnboundMessage({ id }: { id?: string }) {
    return (
        <Container id={id}>
            Fault location no longer exists
            <IssueDisabledPopup type="error" message={issueGroupUnboundMessage} />
        </Container>
    );
}
